import React from 'react';
import PropTypes from 'prop-types';
import { loadCSS } from 'fg-loadcss';
import Icon from '@mui/material/Icon';

const CustomIcon = ({ className, style, color }) => {
    let newStyle = style;

    if (!newStyle) {
        newStyle = { padding: '1px' };
    } else if (!newStyle.padding) {
        newStyle.padding = '1px';
    }

    React.useEffect(() => {
        const node = loadCSS(
            'https://use.fontawesome.com/releases/v5.12.0/css/all.css',
            document.querySelector('#font-awesome-css'),
        );

        return () => {
            node.parentNode.removeChild(node);
        };
    }, []);

    return <Icon className={className} style={newStyle} color={color} />;
};

CustomIcon.propTypes = {
    className: PropTypes.string,
    style: PropTypes.object,
    color: PropTypes.string
};

export default CustomIcon;
